import React from 'react';
import { Box, Typography } from '@mui/material';
import { ArrowForward } from '@mui/icons-material';
import ecoLogo from '../../assets/eco_logo.png';
import { authColors, brandGradient, btnGradient, fontStack } from './authStyles';

// Page d'accueil mobile (maquette F1 Accueil) : panneau de marque plein écran
// avec accroche puis accès à l'inscription / connexion.
const Welcome = ({ onLogin, onRegister }) => {
  const section = { width: '100%', maxWidth: 460 };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        width: '100%',
        boxSizing: 'border-box',
        background: brandGradient,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: '32px',
        p: '56px 28px',
        fontFamily: fontStack,
      }}
    >
      {/* Logo */}
      <Box
        sx={{ ...section, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '12px' }}
      >
        <Box
          sx={{
            width: 48,
            height: 48,
            borderRadius: '14px',
            overflow: 'hidden',
            flexShrink: 0,
            boxShadow: '0 8px 24px rgba(52, 211, 153, 0.33)',
            backgroundColor: 'rgba(0, 0, 0, 0.15)',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'center',
          }}
        >
          <Box
            component="img"
            src={ecoLogo}
            alt="Ecowatch"
            sx={{ width: 48 * 1.2, height: 'auto', objectFit: 'cover', objectPosition: 'top center' }}
          />
        </Box>
        <Typography
          sx={{ color: authColors.textPrimary, fontSize: '20px', fontWeight: 700, letterSpacing: '0.2px' }}
        >
          Ecowatch 360
        </Typography>
      </Box>

      {/* Accroche */}
      <Box sx={{ ...section, display: 'flex', flexDirection: 'column', gap: '18px' }}>
        <Typography
          sx={{ color: authColors.accentGreen, fontSize: '11px', fontWeight: 600, letterSpacing: '2.4px' }}
        >
          PLATEFORME DE SUPERVISION
        </Typography>
        <Typography
          sx={{ color: authColors.textPrimary, fontSize: '32px', fontWeight: 700, lineHeight: 1.15 }}
        >
          Rejoignez la supervision nouvelle génération.
        </Typography>
        <Typography sx={{ color: authColors.textMuted, fontSize: '14px', lineHeight: 1.6 }}>
          Créez votre compte pour suivre vos boîtiers Climatrack, Aquacheck et Greenwatch depuis une
          plateforme unique.
        </Typography>
      </Box>

      {/* Actions */}
      <Box sx={{ ...section, display: 'flex', flexDirection: 'column', gap: '14px' }}>
        <Box
          component="button"
          type="button"
          onClick={onRegister}
          sx={{
            width: '100%',
            height: 52,
            border: 'none',
            cursor: 'pointer',
            borderRadius: '12px',
            background: btnGradient,
            color: authColors.onAccent,
            fontFamily: fontStack,
            fontSize: '15px',
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '10px',
            boxShadow: '0 10px 24px rgba(52, 211, 153, 0.33)',
            transition: 'filter 0.15s ease',
            '&:hover': { filter: 'brightness(1.05)' },
          }}
        >
          Créer un compte
          <ArrowForward sx={{ fontSize: 18 }} />
        </Box>

        <Box
          component="button"
          type="button"
          onClick={onLogin}
          sx={{
            width: '100%',
            height: 52,
            cursor: 'pointer',
            borderRadius: '12px',
            background: 'rgba(255, 255, 255, 0.08)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            color: authColors.textPrimary,
            fontFamily: fontStack,
            fontSize: '15px',
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transition: 'background 0.15s ease',
            '&:hover': { background: 'rgba(255, 255, 255, 0.14)' },
          }}
        >
          Se connecter
        </Box>

        <Typography
          sx={{ color: authColors.textMuted, fontSize: '12px', textAlign: 'center', mt: '4px' }}
        >
          © 2026 Ecowatch 360
        </Typography>
      </Box>
    </Box>
  );
};

export default Welcome;
